import React from 'react';
import LegalLandingPage from './LegalLandingPage';
import { CULINARY_CLOUD_PRIVACY_POLICY } from './legalContent';

const CulinaryCloudPrivacyPolicy: React.FC = () => (
  <LegalLandingPage
    doc={CULINARY_CLOUD_PRIVACY_POLICY}
    footerLinks={[
      { to: '/terms-and-conditions', label: 'Terms and Conditions' },
      { to: '/cookies-policy', label: 'Cookies Policy' },
    ]}
  />
);

export default CulinaryCloudPrivacyPolicy;
